import React from "react";
import Textfield from "@atlaskit/textfield";
import { HelperMessage } from "@atlaskit/form";

const RTextField = ({ title, value, id, helperText, width, isDisabled, onChange, onBlur, isPassword }) => {

  return (
    <>
      {" "}
      <label htmlFor={id}>{title}</label>
      <Textfield
        className="ihub-ext-txt-field"
        name={id}
        value={value}
        isDisabled={isDisabled}
        width={width}
        onChange={onChange}
        onBlur={onBlur}
        type={isPassword ? "password" : "text"}
      />
      <HelperMessage>{helperText}</HelperMessage>
    </>
  );
};
export default RTextField;
